import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface OnePageCheckUpdateInfoParameter extends ApiParameter {
    PhoneNumber: string;
    JobTitle: string;
    CompanyName: string;
    TypeOfBusiness: string;
    UserId: string;
}

const customApiUrl = "/api/v2/UserLookup/UpdateUserInfo";

export function updateContactInfo(parameter: OnePageCheckUpdateInfoParameter) {
    return post<OnePageCheckUpdateInfoParameter>(`${customApiUrl}`, parameter);
}
